export const OPERATION_PERIODS = ['today','7d','30d','90d'];
export const OPERATION_CATEGORIES = ['ALL','CLIENT','STAFF','SALE','INVENTORY','ORDER','SUBSCRIPTION','SECURITY','SYSTEM'];
export function operationFilters(input = {}) {
  const period = OPERATION_PERIODS.includes(input.period) ? input.period : '7d';
  const category = OPERATION_CATEGORIES.includes(input.category) ? input.category : 'ALL';
  const status = ['ALL','SUCCESS','PENDING','FAILED','WARNING'].includes(input.status) ? input.status : 'ALL';
  return {period,category,status,query:String(input.query || '').trim().slice(0,120)};
}
export function operationResponse(result) {
  if (!result || !Array.isArray(result.events)) throw new Error('Operations response must contain an events array.');
  const seen = new Set();
  return {events:result.events.filter(item=>{
    if(!item?.id || !item?.createdAt || seen.has(item.id))return false;
    seen.add(item.id);return true;
  }),nextCursor:result.nextCursor || null,summary:result.summary || null};
}
export function mergeOperations(previous, incoming) {
  const existing = new Set(previous.map(item=>item.id));
  return [...previous,...incoming.filter(item=>!existing.has(item.id))];
}
export function operationalDestination(event) {
  // Only the server-provided page name is used; never open arbitrary URLs from event data.
  const allowed = ['clients','organization','territories','subscriptions','approvals','finance','reports','governance'];
  return allowed.includes(event?.page) ? event.page : null;
}
